import { render, staticRenderFns } from "./FlatRoof.vue?vue&type=template&id=28f62a40&scoped=true"
import script from "./FlatRoof.vue?vue&type=script&lang=js"
export * from "./FlatRoof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f62a40",
  null
  
)

export default component.exports